import { CardContent } from '@material-ui/core';
import { Tooltip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Badge from '@material-ui/core/Badge';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import InfoIcon from '@material-ui/icons/Info';
import React from 'react';
import Typography from '@material-ui/core/Typography';
import useGlobalStyles from '../../styles/globalStyles';
import {useDispatch, useSelector} from "react-redux";
import * as eventRoutines from '../../Containers/Events/eventRoutines';
import {selectFetchingInvitees} from "../../redux/usersSelectors";

interface IUserSync {
    invitee_count: number;
    registrant_count: number;
    active_user_count: number;
    updateActiveUsers: Function;
}
const useStyles = makeStyles(theme => ({
    badge: {
        '& span': { right: 'inherit' },
    },
    importButton: {
        padding:'3px',
        color: theme.palette.common.white,
        backgroundColor: theme.palette.secondary.light,
        '&:hover': {
            backgroundColor: theme.palette.secondary.dark,
            color: theme.palette.common.white,
        },
    },
    action: {
        marginRight: 0,
        marginTop: 0,
        '&:hover': {
            cursor: 'pointer',
        },
        '& svg': {
            fill: theme.palette.secondary.light,
        },
    },
}));
interface IUserStat {
    badgeCount: number;
    icon: string;
    tooltipContent: string;
    tooltip: boolean;
    label: string;
    direction?: 'row' | 'column';
}
//Todo  - look into using @material typings from Icon options
const UserStat = ({ badgeCount, direction = 'column', icon, label, tooltip, tooltipContent }: IUserStat) => {
    const classes = useStyles();

    return (
        <Grid
            alignItems={direction === 'column' ? 'center' : 'flex-start'}
            container
            direction={direction}
            item
            spacing={1}
            xs
        >
            <Grid container item justify="center" xs>
                <Typography component="h5" variant="subtitle1">
                    {label}
                </Typography>
                {tooltip && (
                    <Tooltip placement="top-start" title={tooltipContent}>
                        <InfoIcon color="action" />
                    </Tooltip>
                )}
            </Grid>
            <Grid item style={{ textAlign: 'left' }} xs>
                <Badge badgeContent={badgeCount} className={classes.badge} color="primary" max={100000}>
                    <Icon>{icon}</Icon>
                </Badge>
            </Grid>
        </Grid>
    );
};
const UserSync = ({ active_user_count, invitee_count, registrant_count }: IUserSync) => {
    const globalStyles = useGlobalStyles();
    const classes = useStyles();
    const isFetchingInvitees = useSelector(selectFetchingInvitees)
    const dispatch = useDispatch()
    const syncGuestListWithActiveUsers = () =>{
        dispatch(eventRoutines.syncGuestListWithActiveUsers())
    }

    let tooltipContent =
            <p className={globalStyles.tooltipPopper}>
                By default, only users that have logged into the mobile app will be available to you as members to be
                added to private channels and receipients of notifications. This allows you to supplement those users
                with guests you have invited to the event, but whom haven't yet logged in.
            </p>

    const availableToImportText = 'invitees';
    const toolTipContentForImport = 'The total number of distinct users that have either logged in to the app or been imported.';
    const ToolTip = () => (
        <Tooltip placement="top-end" title={tooltipContent}>
            <InfoIcon color="action" />
        </Tooltip>
    );

    const InviteesAndRegistrants = () => (
        <Grid alignItems="center" container direction="column" item justify="space-between" spacing={2} xs={5}>
            <UserStat
                badgeCount={invitee_count}
                icon="person"
                label="Invitees&nbsp;"
                tooltip={true}
                tooltipContent="The number of users on the guest list for this event"
            />

        </Grid>
    );
    return (
        <Card>
            <CardHeader
                action={<ToolTip />}
                classes={{ root: globalStyles.cardHeader, action: classes.action }}
                title="Mobile App Users"
            />
            <CardContent>
                <Grid  alignItems="center" container justify="center" style={{ flexWrap:'nowrap', paddingTop: '10px' }}>

                     <InviteesAndRegistrants />

                        <Grid item xs={2}>
                            <IconButton
                                className={classes.importButton}
                                data-cy="InviteeImport"
                                onClick={() => syncGuestListWithActiveUsers()}
                            >
                                {isFetchingInvitees ? <Icon className={'spin'}>refresh</Icon>  : <Icon>double_arrow</Icon> }
                            </IconButton>
                        </Grid>

                    <Grid item xs={5}>
                        <UserStat
                            badgeCount={active_user_count}
                            icon="person"
                            label="Active Users&nbsp;"
                            tooltip={true}
                            tooltipContent={toolTipContentForImport}
                        />
                    </Grid>
                </Grid>
                <Divider style={{ margin: '20px' }} />

                    <Typography component="p" variant="subtitle1">
                        By default, only users that have logged into the mobile app will be available for you to add to
                        private channels or send notifiations to. Use this area to import event {availableToImportText}{' '}
                        that have not yet logged in to the mobile app so that you can perform the above actions on those
                        users as well.
                    </Typography>

                <Divider style={{ margin: '20px' }} />
            </CardContent>
        </Card>
    );
};

export default UserSync;
